// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'

export default {
  MenuProjects: codeSplit({
    l10n: {},
    loadComponent: () =>
      import(
        /* webpackChunkName: "MenuProjects" */
        './index'
      ),
  }),
}
